import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Menu } from '@wds/menu';
import { IconMenu, IconLogoGoldie } from '@sm/wds-icons';

const DeveloperWebNavHeaderMobile = ({ navItems, domain, subdomain, url }) => {
  return (
    <div className="sm-app-dir-nav-header wds-p-t-3 wds-p-b-3 wds-flex wds-flex--y-center wds-flex--between">
      <span className="wds-type wds-type--light wds-type--section-title">
        <IconLogoGoldie size="xl" />
      </span>
      <div>
        <Menu
          autoClose
          noRules
          dense
          placement="bottom-right"
          menuTrigger={
            <div
              className="sm-app-dir-nav-header__nav-user-trigger sm-app-dir-nav-header__nav-user-trigger--mobile"
              data-testid="DeveloperWebNavHeaderMobile__UnauthenticatedUserMenuTrigger"
            >
              <span className="wds-type wds-type--section-title wds-type--light">
                <IconMenu size="lg" />
              </span>
            </div>
          }
        >
          {navItems.map(nav => (
            // The query params need to be preserved between urls (needed for ut_source)
            <Menu.Item isNavigable navigationTarget={nav.target} key={nav.target}>
              {nav.text}
            </Menu.Item>
          ))}
          <Menu.Item
            isNavigable
            navigationTarget={
              domain ? `https://${subdomain}.${domain}.com/user/sign-in?ep=${encodeURIComponent(url)}` : '/user/sign-in'
            }
          >
            Sign In
          </Menu.Item>
          <Menu.Item
            isNavigable
            navigationTarget={
              domain ? `https://${subdomain}.${domain}.com/user/sign-up?ep=${encodeURIComponent(url)}` : '/user/sign-up'
            }
          >
            Sign Up
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
};

DeveloperWebNavHeaderMobile.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      target: PropTypes.string.isRequired,
      text: PropTypes.node.isRequired,
      class: PropTypes.string,
    })
  ).isRequired,
  domain: PropTypes.string.isRequired,
  subdomain: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default withRouter(DeveloperWebNavHeaderMobile);
